import React from "react";
import styled from "styled-components";
import { PRIMARY } from "../../const/colors";
import MuiMenuIcon from "@mui/icons-material/Menu";

const NavIcon = styled.div.attrs((props) => ({
  className: props.className,
}))`
  // width: 30px;
  // height: 30px;
  position: relative;
  transition: 0.1s;
  margin: 10px 10px;
  cursor: pointer;
  display: inline-block;
  margin: 5px;
`;

const MenuIcon2 = ({ clicked, handleClick }) => {
  return (
    <NavIcon onClick={handleClick} className={clicked ? "open" : ""}>
      <MuiMenuIcon style={{ color: PRIMARY, fontSize: 35 }} />{" "}
    </NavIcon>
  );
};

export default MenuIcon2;
